module.exports = __webpack_public_path__ + "img/checklist.ac055e06.svg";